import React from 'react';

export type ChipVariant = 'completed' | 'pending' | 'deleted';

export type ChipStatusProps = React.PropsWithChildren<{
  variant?: ChipVariant;
}>;

const GetClassName = (variant: ChipVariant) => {
  let containerClassName;

  switch (variant) {
    case 'completed': {
      containerClassName = 'container-light-green';
      break;
    }

    case 'pending': {
      containerClassName = 'container-light-grey';
      break;
    }

    case 'deleted': {
      containerClassName = 'container-light-red';
      break;
    }
  }

  return containerClassName;
};

const Chip = ({ children, variant = 'completed' }: ChipStatusProps) => {
  return (
    <div className={`status-box ${GetClassName(variant)}`}>
      <span className={'status-text text-capitalize text-caption'}>
        {children ? children : variant}
      </span>
    </div>
  );
};

export default Chip;
